var image_upload_default = {
  "container": "iAqMl",
  "disabled": "i6FA6",
  "imageInput": "g6Wj-",
  "overlay": "UkzOX",
  "text": "Jox2d",
  "shown": "_6M505",
  "hide": "Jn7aP",
  "spinner": "CkSw4",
  "spin": "iyNTl"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
